import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import { cn } from '@/lib/utils';

import { LOAChaserWidget, LOAChaserWidgetProps } from './LOAChaserWidget';

export interface LegacyLOAChaserSectionProps extends LOAChaserWidgetProps {
  /** Default open state */
  defaultOpen?: boolean;
}

export const LegacyLOAChaserSection: React.FC<LegacyLOAChaserSectionProps> = ({
  defaultOpen = false,
  ...widgetProps
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <CollapsibleTrigger asChild>
        <button
          type="button"
          className={cn(
            'w-full flex items-center justify-between px-3 py-2 text-xs font-medium',
            'bg-zinc-50 hover:bg-zinc-100 border border-zinc-200 rounded-lg transition-colors',
            'text-zinc-600 hover:text-zinc-800'
          )}
        >
          <span>Legacy LOA Actions</span>
          <ChevronDown
            className={cn(
              'h-4 w-4 transition-transform',
              isOpen && 'rotate-180'
            )}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="pt-2">
        <LOAChaserWidget {...widgetProps} />
      </CollapsibleContent>
    </Collapsible>
  );
};

export default LegacyLOAChaserSection;
